import React, { useState } from 'react';
import DsButton from '../../common/DsButton';
import ChatTargetSearchModal from '../../common/chat/search/ChatTargetSearchModal';
import ChatCastingSearchFields, { emptyChatCastingFilter, type ChatCastingFilter } from './ChatCastingSearchFields';

export default function BroadcastCastingFilterControl({ value, onChange }: {
  value: ChatCastingFilter;
  onChange: (_value: ChatCastingFilter) => void;
}) {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(value);
  return <>
    <DsButton variant="secondary" size="sm" aria-expanded={open} onClick={() => { setDraft(value); setOpen(true); }}>
      オファー／本契約条件{value.eventId ? ' (設定中)' : ''}
    </DsButton>
    {value.eventId ? <DsButton variant="secondary" size="sm" onClick={() => onChange(emptyChatCastingFilter)}>送付条件を解除</DsButton> : null}
    <ChatTargetSearchModal isOpen={open} onClose={() => setOpen(false)} title="オファー／本契約条件" onRetry={undefined}
      onClear={() => { onChange(emptyChatCastingFilter); setOpen(false); }}
      onApply={() => { onChange(draft); setOpen(false); }}>
      <div className="chat-target-search-form"><ChatCastingSearchFields value={draft} onChange={setDraft} /></div>
    </ChatTargetSearchModal>
  </>;
}
